import { Page } from "@/ui/Layout/Page";
import { useContext, useEffect, useRef } from "react";
import { AppContext } from "@/AppContext";

export const Concierge = ({ name = "" }) => {
  const { permissions = [] } = useContext(AppContext);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const permissionsParam = encodeURIComponent(permissions.join(','));
  
  // Send permissions to iframe via postMessage when iframe loads or permissions change
  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;
    
    const sendPermissions = () => {
      if (iframe.contentWindow) {
        const message = {
          type: 'LAUNCHOS_PERMISSIONS',
          permissions: permissions,
        };
        // iframe.contentWindow.postMessage(message, 'http://localhost:3006');
        iframe.contentWindow.postMessage(message, "https://clients.launchos.com");
        console.log('[Concierge] Sent permissions to iframe:', permissions);
      }
    };
    
    // Send when iframe loads
    iframe.addEventListener('load', sendPermissions);
    
    // Send immediately if already loaded
    sendPermissions();
    
    return () => {
      iframe.removeEventListener('load', sendPermissions);
    };
  }, [permissions]);
  
  return (
    <Page topBar={{ page: [{ label: name }] }}>
      <div className="w-full h-full">
        <iframe
          ref={iframeRef}
          //  src={`http://localhost:3006/docs?permissions=${permissionsParam}`}
          src={`https://docs-concierge.vercel.app/docs?permissions=${permissionsParam}`}
          className="w-full h-full border-0"
          title="Concierge Documentation"
        />
      </div>
    </Page>
  );
};

